import { combineDesignationSalution } from '../../../global/helpers/form-data-helper';
import { getFormatedPhone } from '../../../global/helpers/transformer';
import { Person } from '../../../global/models/person-model';
import { EmailFields, MailingAddressFields, PersonalInfoFields, PhoneFields } from '../models/form-models';

export function getInitialPersonInfo(person: Person): PersonalInfoFields {
	return {
		designation_salutation: combineDesignationSalution(person?.designation, person?.salutation),
		first_name: person?.first_name || '',
		middle_name: person?.middle_name || '',
		last_name: person?.last_name || '',
		suffix: person?.suffix || '',
		known_as: person?.known_as || '',
		gender: person?.gender || '',
		gender_identity: person?.gender_identity || [],
		gender_identity_other: person?.gender_identity_other || '',
		date_of_birth: person?.masked_date_of_birth || null,
		tax_id: person?.masked_tax_id || '',
	};
}

export function getInitialMailingAddress(person: Person): MailingAddressFields {
	return {
		mailing_address_1: person?.masked_mailing_address_1 || '',
		mailing_address_2: person?.masked_mailing_address_2 || '',
		mailing_address_3: person?.masked_mailing_address_3 || '',
		mailing_country: person?.mailing_country || '',
		mailing_city: person?.mailing_city || '',
		mailing_state: person?.mailing_state || '',
		mailing_postal_code: person?.mailing_postal_code || '',
	};
}

export function getInitialPhones(person: Person): PhoneFields {
	return {
		business_phone_country_code: person?.business_phone_country_code || '',
		business_phone_area_code: person?.business_phone_area_code || '',
		business_phone_number: person?.business_phone_number || '',
		business_phone_formated: getFormatedPhone(person?.business_phone_area_code, person?.business_phone_number),
		business_phone_extension: person?.business_phone_extension || '',

		home_phone_country_code: person?.home_phone_country_code || '',
		home_phone_area_code: person?.home_phone_area_code || '',
		home_phone_number: person?.home_phone_number || '',
		home_phone_formated: getFormatedPhone(person?.home_phone_area_code, person?.home_phone_number),
		home_phone_extension: person?.home_phone_extension || '',

		mobile_phone_country_code: person?.mobile_phone_country_code || '',
		mobile_phone_area_code: person?.mobile_phone_area_code || '',
		mobile_phone_number: person?.mobile_phone_number || '',
		mobile_phone_formated: getFormatedPhone(person?.mobile_phone_area_code, person?.mobile_phone_number),
		mobile_phone_extension: person?.mobile_phone_extension || '',
	};
}

export function getInitialEmails(person: Person): EmailFields {
	return {
		office_email_address: person?.office_email_address || '',
		personal_email_address: person?.personal_email_address || '',
	};
}